import { ValidatorFn, AbstractControl, ValidationErrors, UntypedFormGroup, FormControl } from "@angular/forms";

export class Constants {
    static TELEPHONE_VALIDATION_REGEXP: string = '^([+]|[00]{2})[0-9 ]{0,3}([(][0-9]{1,4}[)])?[0-9 ]*[-]?[ ]?[0-9]{0,3}$';
    static MOBILE_PHONE_VALIDATION_REGEXP: string = '^([+]|[00]{2})[0-9 ]{0,3}([(][0-9]{1,4}[)])?[0-9 ]*[-]?[ ]?[0-9]{0,3}$';
    static EMAIL_VALIDATION_REGEXP: string = '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
}

export class CustomFormValidators {
    static getModel<TModel>(value: AbstractControl | TModel): TModel {
        if (value instanceof AbstractControl) {
            return value.value;
        } else {
            return value;
        }
    }
}

export const phoneValidator: ValidatorFn = (control: AbstractControl | string): ValidationErrors | null => {
    if (!control)
        return null;

    let phone: string = CustomFormValidators.getModel(control);
    if (phone)
        phone = phone.trim();

    return !phone || new RegExp(Constants.TELEPHONE_VALIDATION_REGEXP).test(phone) ? null : { phone: true };
};

export const emailValidator: ValidatorFn = (control: AbstractControl | string): ValidationErrors | null => {
    if (!control)
        return null

    let email: string = CustomFormValidators.getModel(control);
    if (email)
        email = email.trim();

    return !email || new RegExp(Constants.EMAIL_VALIDATION_REGEXP).test(email) ? null : { email: true };
};

export const projektstartValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
        let today = new Date();
        today.setDate(today.getDate() - 1);
        const dateToCheck = new Date(control.value);
        if (dateToCheck < today) {
            return { invalidDate: true }
        }
    }
    return null;
};

// Is FormControl dateA before dateB => return object with dateAAfterDateB = true
export const dateABeforeDateBValidator = (dateA: FormControl, dateB: FormControl): ValidatorFn => {
    return (): ValidationErrors | null => {
        const dateAValue = dateA?.value;
        const dateBValue = dateB?.value;

        if (dateAValue && dateBValue) {
            if (new Date(dateBValue) > new Date(dateAValue)) {
                return { dateAAfterDateB: true };
            }
        }

        return null;
    };
};

export const financeFoerdersummeValidator: ValidatorFn = (control: AbstractControl | string): ValidationErrors | null => {
    if (!control)
        return null

    let foerdersumme: number = +CustomFormValidators.getModel(control);

    return foerdersumme > 0 ? null : { foerdersumme: true };
};
